var BaseView = (function (RoutedView, _, DisplayRouter, eventEmitter, globalUrls) {
	return RoutedView.extend({

		disabled: false,

		constructor: function (opts) {
			opts = opts || {};

			if (opts.displayRouter) {
				this._displayRouter = opts.displayRouter;
			}

			if (this.displayRoutes && this.displayRoutes.length) {
				this._displayRouter.listen(this.displayRoutes, _.bind(this.show, this), _.bind(this.hide, this));
			}

			RoutedView.prototype.constructor.apply(this, arguments);
		},

		setBackCallback: function (cb) {
			eventEmitter.trigger('changeLeftButton', {
				func: cb || function () {
					window.location = globalUrls.shop;
				},
				isClearActions: true
			});
		},

		show: function () {
			if (this.disabled) return;

			this.beforeShow.apply(this, arguments);
			this.beforeDisplay.apply(this, arguments);

			var _arguments = arguments;
			this.$el.show(0, _.bind(function () {
				this.afterShow.apply(this, _arguments);
				this.afterDisplay.apply(this, _arguments);
			}, this));
		},

		hide: function () {
			this.beforeHide.apply(this, arguments);
			this.beforeDisplay.apply(this, arguments);

			var _arguments = arguments;
			this.$el.hide(0, _.bind(function () {
				this.afterHide.apply(this, _arguments);
				this.afterDisplay.apply(this, _arguments);
			}, this));
		},

		beforeShow: function () { },

		beforeHide: function () { },

		beforeDisplay: function () { },

		afterShow: function () {
			var prev = this._displayRouter.getHistoryPrev();
			if (prev) {
				this.setBackCallback(_.bind(function () {
					this.display(prev);
				}, this));
			} else {
				this.setBackCallback();
			}
		},

		afterHide: function () { },

		afterDisplay: function () { }
	});
})(RoutedView, _, DisplayRouter, eventEmitter, globalUrls);